import { updateCompanyIdAction } from '../actions/update-company-id';

export function updateCompanyId(companyId: string) {
    return (dispatch, getState) => {
        dispatch(updateCompanyIdAction(companyId));
        return getState();
    };
};
